import { topics } from "@/mocks/topics";
import { categories } from "@/mocks/categories";
import { discussions } from "@/mocks/discussions";
import { testimonials } from "@/mocks/testimonials";
import usePageSeo from "@/hooks/usePageSeo";
import Hero from "./components/Hero";
import TodayTopics from "./components/TodayTopics";
import RankingAndDiscussion from "./components/RankingAndDiscussion";
import CategoryGrid from "./components/CategoryGrid";
import VoiceSection from "./components/VoiceSection";
import CtaBand from "./components/CtaBand";

const ORIGIN = "https://houaiw.cn";

export default function Home() {
  const ranked = [...topics].sort((a, b) => b.heat - a.heat);
  const todayTopics = topics.slice(0, 4);

  usePageSeo({
    title: "瓜田吃瓜 - 热门话题、讨论区与观点交锋一站式围观",
    description:
      "瓜田吃瓜汇聚综艺、影视、音乐、演出等热门话题，讨论区汇集不同立场的观点交锋，事件时间线与最新回转一站吃透，理性围观不站队。",
    keywords: "瓜田吃瓜,瓜田吃瓜热门话题,瓜田吃瓜讨论区,瓜田吃瓜观点交锋,瓜田吃瓜话题榜",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "瓜田吃瓜",
        url: `${ORIGIN}/`,
        inLanguage: "zh-CN",
        description:
          "泛娱乐话题聚合与观点讨论社区，集中呈现热门话题、事件脉络与不同立场的观点交锋。",
        publisher: {
          "@type": "Organization",
          name: "瓜田吃瓜",
          url: `${ORIGIN}/`,
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "瓜田吃瓜",
        url: `${ORIGIN}/`,
        email: "hello@guatianchigua.cn",
        description:
          "以话题整理和观点讨论为核心的内容社区，覆盖综艺、影视、音乐、演出、明星动态与行业观察。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "瓜田吃瓜热门话题榜",
        itemListElement: ranked.slice(0, 8).map((topic, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: topic.title,
          url: `${ORIGIN}/topic/${topic.id}`,
        })),
      },
    ],
  });

  return (
    <>
      <Hero hotTopics={ranked} />
      <TodayTopics topics={todayTopics} />
      <RankingAndDiscussion topics={ranked.slice(0, 5)} discussions={discussions.slice(0, 3)} />
      <CategoryGrid categories={categories} />
      <VoiceSection testimonials={testimonials} />
      <CtaBand />
    </>
  );
}